import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import Coin from './Coin';
import Footer from './Footer/Footer';

function App() {
  const [coins, setCoins] = useState([]);
  const [search, setSearch] = useState('');
  const [darkMode, setDarkMode] = useState(true);
  const [placeholder, setPlaceholder] = useState('');

  // Typewriter effect
  useEffect(() => {
    const text = "Search a currency...";
    let index = 0;
    let isDeleting = false;
    let timeoutId;

    const type = () => {
      setPlaceholder(prev => {
        if (!isDeleting && index <= text.length) {
          index++;
          return text.substring(0, index);
        } else if (isDeleting && index >= 0) {
          index--;
          return text.substring(0, index);
        }
        return prev;
      });

      if (!isDeleting && index === text.length) {
        isDeleting = true;
        timeoutId = setTimeout(type, 2000); // Wait before deleting
      } else if (isDeleting && index === 0) {
        isDeleting = false;
        timeoutId = setTimeout(type, 500); // Wait before typing again
      } else {
        const speed = isDeleting ? 50 : 150;
        timeoutId = setTimeout(type, speed);
      }
    };

    timeoutId = setTimeout(type, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    document.body.className = darkMode ? 'dark-mode' : 'light-mode';
  }, [darkMode]);

  useEffect(() => {
    axios.get('https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=100&page=1&sparkline=false')
      .then(res => {
        setCoins(res.data);
        // console.log(res.data);
      }).catch(error => alert('You have an error!'));
  }, []);

  const handlechange = e => {
    setSearch(e.target.value)
  }

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  }

  const filteredCoins = coins.filter(coin =>
    coin.name.toLowerCase().includes(search.toLowerCase()))

  return (
    <div className={`coin-app`}>
      <div className="coin-search">
        <h1 className="app-title" style={{ fontSize: '3rem', marginBottom: '20px', textAlign: 'center' }}>Cryptocurrency Price Tracker</h1>
        <div style={{ position: 'absolute', top: '20px', right: '30px' }}>
          <button onClick={toggleTheme} style={{
            padding: '10px 20px',
            cursor: 'pointer',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: 'transparent',
            fontSize: '2rem'
          }}>
            {darkMode ? '☀️' : '🌙'}
          </button>
        </div>
        <h1 className="coin-text">Search a currency</h1>
        <form>
          <input type="text" placeholder={placeholder} className="coin-input" onChange={handlechange} />
        </form>
      </div>

      <div className='coin-container'>
        <div className='coin-row' style={{ borderBottom: '2px solid #d7d7d7', fontWeight: 'bold' }}>
          <div className='coin'>
            <div style={{ width: '30px', marginRight: '10px' }}></div>
            <h1>Name</h1>
            <p className='coin-symbol'>Symbol</p>
          </div>
          <div className='coin-data'>
            <p className='coin-price'>Price</p>
            <p className='coin-volume'>Volume</p>
            <p className='coin-lastupdated'>Last Updated</p>
            <p className='coin-percent'>Change</p>
            <p className='coin-marketcap'>Mkt Cap</p>
            <p className='coin-marketcaprank'>Rank</p>
          </div>
        </div>
      </div>

      {filteredCoins.map(coin => {
        return (
          <Coin
            key={coin.id}
            name={coin.name}
            image={coin.image}
            symbol={coin.symbol}
            marketcap={coin.market_cap}
            price={coin.current_price}
            priceChange={coin.price_change_percentage_24h}
            volume={coin.total_volume}
            marketcaprank={coin.market_cap_rank}
            lastupdated={coin.last_updated}
          />
        );
      })}
      <Footer />
    </div>
  );
}

export default App;
